import React, { Component } from 'react';
import { Icon, Input, Select, Form, message, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

import Description from 'components/Description/Description';
import { getMYStates } from 'utils/apis/constants';
import GoogleMapsSearch from 'components/GoogleMapsSearch/GoogleMapsSearch';
import { SEARCH_MODE_BY_STATE, SEARCH_MODE_BY_ADDRESS, DEFAULT_MAP_LOCATION } from 'utils/constants';
import Button from 'components/Button/Button';

const WrappedGoogleMapsSearch = Form.create()(GoogleMapsSearch);
WrappedGoogleMapsSearch.displayName = 'WrappedGoogleMapsSearch';

const Option = Select.Option;
const InputGroup = Input.Group;

const searchSelections = [
  {
    key: SEARCH_MODE_BY_ADDRESS,
    value: 'Address'
  },
  {
    key: SEARCH_MODE_BY_STATE,
    value: 'State'
  }
];

const allSelectionObj = { key: 'All', value: 'All' };

class PlaceSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: SEARCH_MODE_BY_ADDRESS,
      states: [],
      selectedState: '',
      place: {},
      selectedPlaceCoordinate: {
        latitude: DEFAULT_MAP_LOCATION.lat,
        longitude: DEFAULT_MAP_LOCATION.lng
      }
    };
  }

  componentDidMount() {
    return this.fetchState();
  }

  fetchState() {
    return getMYStates()
      .then(res => {
        this.setState({
          states: [
            allSelectionObj,
            ...Object.values(res.data).map(state => ({
              key: state.code,
              value: state.label
            }))
          ]
        });
      })
      .catch(e => {
        console.error(e);
        message.error('Error while fetching location data');
      });
  }

  handleSearchTypeChange = value => {
    this.setState({ mode: value });
  };

  handleOnGoogleMapInputChange = e => {
    this.setState({ place: { addressDisplayed: e.target.value } });
  };

  handleOnPlaceChange = async place => {
    const { setDisplayAddress } = this.props;
    let selectedPlaceCoordinate;
    if (place) {
      if (place.geometry) {
        selectedPlaceCoordinate = {
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng()
        };
      } else {
        const coordinate = await this.getLocation(place.addressDisplayed);
        selectedPlaceCoordinate = {
          latitude: coordinate.lat,
          longitude: coordinate.lng
        };
      }
      setDisplayAddress(place.addressDisplayed);
      this.setState({
        selectedPlaceCoordinate
      });
    }
  };

  handleOnSearch = () => {
    const { mode, place, selectedPlaceCoordinate, selectedState } = this.state;
    const { onSearch } = this.props;
    onSearch({ mode, selectedPlaceCoordinate, selectedState, place });
  };

  handleOnStateChange = async selectedState => {
    let coordinateOfState = DEFAULT_MAP_LOCATION;
    if (selectedState !== 'All') {
      coordinateOfState = await this.getLocation(`${selectedState}, Malaysia`);
    }
    this.setState({
      selectedState,
      selectedPlaceCoordinate: {
        latitude: coordinateOfState.lat,
        longitude: coordinateOfState.lng
      }
    });
  };

  getLocation = async address => {
    return geocodeByAddress(address).then(results => getLatLng(results[0])).catch((ex) => {
      console.warn(`geocodeByAddress failed for address ${address}`)
      console.warn(ex);
      return DEFAULT_MAP_LOCATION
    });
  };

  render() {
    const { mode, states } = this.state;
    const { size, label, helperText, defaultAddress } = this.props;
    return (
      <>
        <Description size={size}>{label}</Description>
        <InputGroup size={size} compact>
          <Select size={size} style={{ width: '25%' }} defaultValue={SEARCH_MODE_BY_ADDRESS} onChange={this.handleSearchTypeChange}>
            {searchSelections.map(selection => {
              return (
                <Option key={selection.key} value={selection.key}>
                  {selection.value}
                </Option>
              );
            })}
          </Select>
          <Row style={{ width: '75%' }}>
            <Col span={21}>
              {mode === SEARCH_MODE_BY_ADDRESS ? (
                <WrappedGoogleMapsSearch
                  size={size}
                  onPlaceChange={this.handleOnPlaceChange}
                  onInputChange={this.handleOnGoogleMapInputChange}
                  defaultValue={defaultAddress}
                  style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                />
              ) : (
                <Select
                  size={size}
                  style={{ width: '100%', marginBottom: '24px' }}
                  placeholder="Select a state"
                  onChange={this.handleOnStateChange}
                >
                  {states.map(selection => (
                    <Option key={selection.key} value={selection.key}>
                      {selection.value}
                    </Option>
                  ))}
                </Select>
              )}
            </Col>
            <Col span={2}>
              <Button type="host-search" onClick={this.handleOnSearch} round="true">
                <Icon type="search" style={{ fontSize: '18px' }} />
              </Button>
            </Col>
          </Row>
        </InputGroup>
        {helperText && <Description size="small">{helperText}</Description>}
      </>
    );
  }
}

PlaceSearch.propTypes = {
  defaultAddress: PropTypes.string,
  size: PropTypes.oneOf(['small', 'default', 'large']),
  label: PropTypes.string,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

PlaceSearch.defaultProps = {
  size: 'default',
  helperText: '',
  onSearch: () => {}
};

export default PlaceSearch;
